import { Checkout } from 'ui/components/3-organisms/Checkout';

export const CheckoutFeature: React.FC<Umbraco.checkout> = ({ content }) => {
	return <Checkout {...content.properties} />;
};
